module.exports = __webpack_public_path__ + "img/EMT-SCC_GSE144240.e8b021ca.png";